export default __webpack_public_path__ + "static/media/IntegrationBanner.14b42bd5.png";